import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminSuppliersBulkActionsService } from './bulk-actions.service';

@Component({
    selector: 'bulk-action-layout',
    template: `
        <page-header
            [titleText]="pageHeader"
            backButtonText="Back to suppliers"
            (handleBackButtonClick)="backToSuppliers()"
        >
        </page-header>
        <div class="container-fluid page-container">
            <div class="row">
                <div class="col-12 col-md-8 order-2 order-md-1">
                    <card
                        [headerTitle]="
                            (supplierCount | number) +
                            (supplierCount > 1 ? ' Suppliers' : ' Supplier')
                        "
                    >
                        <div card-body [style.overflowX]="'auto'">
                            <ng-content select="[supplier-table]"></ng-content>
                        </div>
                    </card>
                </div>
                <div class="col-12 col-md-4 order-1 order-md-2">
                    <card headerTitle="New Setting Summary" [hasFooter]="true">
                        <div card-body [style.padding]="'2rem 3rem 3rem'">
                            <ng-content select="[confirm-card]"></ng-content>
                        </div>
                        <div card-footer [style.padding]="'2rem 3rem 3rem'">
                            <lsq-checkbox
                                [style.display]="'block'"
                                [style.marginBottom]="'2rem'"
                                [(ngModel)]="checked"
                                [label]="checkboxLabel"
                            ></lsq-checkbox>
                            <lsq-button
                                [style.display]="'block'"
                                size="block"
                                [disabled]="!checked || disableConfirm"
                                [submitting]="isSubmittingBulkAction$ | async"
                                (buttonClick)="confirmClickHandler.emit()"
                            >
                                {{ confirmButtonText }}
                            </lsq-button>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    `
})
export class AdminSuppliersBulkActionLayoutComponent {
    @Input() public pageHeader: string;
    @Input() public supplierCount: number;
    @Input() public confirmButtonText: string;
    @Input() public disableConfirm = false;
    @Output() public confirmClickHandler = new EventEmitter();

    public checked = false;
    public isSubmittingBulkAction$ = this._adminSuppliersBulkActionsService.isSubmittingBulkAction$;

    public readonly checkboxLabel =
        'By performing this action, I acknowledge that all of the provided information for the provided suppliers has been reviewed and verified.';
    constructor(private _adminSuppliersBulkActionsService: AdminSuppliersBulkActionsService) {}

    public backToSuppliers(): void {
        this._adminSuppliersBulkActionsService.cancelBulkAction();
    }
}
